module.exports = __webpack_public_path__ + "static/media/Tution.5f008041.png";